import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';

export const ImageHeaderContainer = styled(Flex, {
  marginBottom: '56px',
  justifyContent: 'center',
  marginTop: '24px',

  '@screen < $sm': {
    marginTop: '12px',
  },
});

export const StyledFAQContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '24px',
});

export const OnboardingDisclaimerContainer = styled('div', {
  marginTop: '24px',
});

export const OnboardingHeading = styled('div', {
  fontSize: '32.45px !important',
  fontFamily: '$heading',
  lineHeight: '40px !important',
  color: '$primary1',
  fontWeight: '$semibold',
  '&.abyss-heading-root': {
    fontFamily: '$heading',
    fontWeight: '$semibold',
  },
});
